import ProgressBar from './ProgressBar';
import Circle2     from 'vue-loading-spinner/src/components/Circle2.vue';



export default {
  ProgressBar,
  Circle2,
}



// WEBPACK FOOTER //
// ./src/js/ui/components/progresses/index.js